﻿import { validateRegex, isPurchaseOrderNumberValid } from './validate';

export function validation() {
  const debugFunction = false;
  const EARMOLD_SELECTION = Object.freeze({
    right: 'Right',
    left: 'Left',
    binaural: 'Binaural',
  });

  const consoleInfo = 'background: #ECBE13; color: #fff; padding: 4px 10px;';
  const consoleParentTrue =
    'background: #77AB59; color: #fff; padding: 4px 10px;border-left:40px solid white;';
  const consoleParentTrueGap =
    'background: #77AB59; color: #fff; padding: 4px 10px;border-left:40px solid white;margin-bottom:20px;';
  const consoleParentFalse =
    'background: #E35B5D; color: #fff; padding: 4px 10px;border-left:40px solid white;';
  const consoleParentFalseGap =
    'background: #E35B5D; color: #fff; padding: 4px 10px;border-left:40px solid white;margin-bottom:20px;';
  const consoleChildTrue =
    'background: #77AB59; color: #fff; padding: 2px 10px;border-left:80px solid white;';
  const consoleChildFalse =
    'background: #E35B5D; color: #fff; padding: 2px 10px;border-left:80px solid white;';

  if (debugFunction) {
    console.log('%c Validation ', consoleInfo);
  }

  const requiredQuestions = document.querySelectorAll(
    '.configurator__label--required, .label--required',
  );
  const addToCartBtn = document.querySelector('.add_to_cart-hcp');
  const summaryErrors = document.querySelector('.configurator_summary__errors');
  const leftSideString = document.querySelector(
    '.configurator__selector__side.configurator__selector__side--left label',
  ).innerHTML;
  const rightSideString = document.querySelector(
    '.configurator__selector__side.configurator__selector__side--right label',
  ).innerHTML;
  let checkPageQuestions = [];
  let checkPageQuestionsHeadings = [];
  checkQuestionGeneric(false);

  // Check if page is valid
  function checkPage(displayError) {
    checkPurchaseOrderNumber(displayError);

    if (debugFunction) {
      console.log('%c Questions not valid: ' + checkPageQuestions + ' ', consoleParentFalse);
      console.log(
        '%c Questions headings not valid: ' + checkPageQuestionsHeadings + ' ',
        consoleParentFalse,
      );
    }

    if (checkPageQuestions.length === 0) {
      if (debugFunction) {
        console.log('%c Page is valid ', consoleParentTrueGap);
      }

      summaryErrors.classList.add('is-hidden');
      addToCartBtn?.classList.remove('is-disabled');

      return true;
    } else {
      if (debugFunction) {
        console.log('%c Page is not valid ', consoleParentFalseGap);
      }

      if (displayError) {
        summaryErrors.classList.remove('is-hidden');
        // Error position depends on sibling elements height
        const siblingHeight = window
          .getComputedStyle(document.querySelector('.cta_controller'))
          .getPropertyValue('height');
        summaryErrors.style.bottom = siblingHeight;
        validateRegex();
      }

      addToCartBtn?.classList.add('is-disabled');

      return false;
    }
  }

  function checkPurchaseOrderNumber(displayError) {
    const section = document.querySelector('[id*="PurchaseOrderNumberSection"]');
    const input = section?.querySelector('[id*="PurchaseOrderNoTextBox"]');
    const cellPatient = section?.querySelector('.configureCellPatient');
    const { isValid, message } = isPurchaseOrderNumberValid(input);

    if (isValid) {
      section?.classList.remove('has-error');
      cellPatient?.classList.remove('is-invalid');
    } else {
      const errorMessages = document.querySelector('.configurator_summary__errors ul');
      const errorId = 'purchase-order-number-error';
      const existingError = errorMessages?.querySelector(`#${errorId}`);
      checkPageQuestions.push(errorId);

      if (existingError) {
        existingError.innerText = message;
      } else {
        const node = document.createElement('li');
        const messageNode = document.createTextNode(message);
        node.appendChild(messageNode);
        node.setAttribute('id', errorId);
        errorMessages?.appendChild(node);
      }

      if (displayError) {
        section?.classList.add('has-error');
        cellPatient?.classList.add('is-invalid');
      } else {
        section?.classList.remove('has-error');
        cellPatient?.classList.remove('is-invalid');
      }
    }
  }

  // This will/can be replaced on BE by using existing required functionality to add class server side
  requiredQuestions.forEach((question) => {
    if (debugFunction) {
      console.log('%c Add new classes for consistency ', consoleInfo);
    }
    const questionSubsection = question.closest('.configurator__section__fields__subsection');
    const questionFormGroup = question.closest('.form-group');

    if (questionSubsection) {
      questionSubsection.classList.add('is-required', 'is-required-wrapper');
    } else if (questionFormGroup) {
      questionFormGroup.classList.add('is-required', 'is-required-wrapper');
    }
  });

  // On click
  // Loop through all h2's with required class
  // Find specific parent and apply class so we can target entire question
  // For each required question loop through inputs and find if its a text, select, checkbox etc
  // Check that input is valid on a question by question basis
  // If invalid assign that item to array for each specific question
  // Add help text to left for each question
  // If question is invalid assign it to an overal array for each errored question
  // As user fixes issues update array on each question
  // If question has no invalids remove it from overall array
  // When overall array is empty then page is valid

  function checkQuestionGeneric(displayError) {
    if (debugFunction) {
      console.log('%c checkQuestionGeneric ', consoleInfo);
    }
    checkPageQuestions = [];

    // Loop through all required questions
    const requiredWrappers = document.querySelectorAll('.is-required-wrapper, .requiredAudiogram');
    const requiredWrappersVisible = [...requiredWrappers].filter(
      (element) =>
        !element.closest('.configurator__section__fields--disabled') &&
        element.style.display !== 'none',
    );

    requiredWrappersVisible.forEach((wrapper, i) => {
      let heading = wrapper.querySelector('label')
        ? wrapper.querySelector('label').innerText.trim().replace('*', '').replace(':', '')
        : null;
      // Audiogram heading
      if (wrapper.querySelector('.audiogram__graph-frame')) {
        const headings = wrapper.closest('.configurator__section').querySelectorAll('h2, h3');
        const arrayOfHeadings = Array.from(headings);
        // Find first heading without an empty string
        heading = arrayOfHeadings
          .find((el) => el.innerText.length > 1)
          .innerText.trim()
          .replace('*', '')
          .replace(':', '');
      }
      const uniqueId = 'requiredItem' + i;

      // Bundled vs Unbundled
      let bundled = wrapper.querySelectorAll('input[type="checkbox"]');
      if (bundled.length > 0) {
        bundled = true;
      } else {
        bundled = false;
      }

      if (debugFunction) {
        console.log('%c ' + heading + ' Found ', consoleParentTrue);
        if (bundled) {
          console.log('%c ' + heading + ' Bundled ', consoleParentTrue);
        }
      }

      let questionToValidateConditional = '';
      const checkQuestionsInvalid = [];
      const itemsToValidate = [];
      const errorMessageList = document.querySelector('.configurator_summary__errors ul');

      // For Inputs
      // e.g Patient Name, Chargers
      const inputFields = wrapper.querySelectorAll('input');
      const inputFieldsNoAudiogram = [...inputFields].filter(
        (element) => !element.closest('#cssConfigureAudiogram'),
      );

      inputFieldsNoAudiogram.forEach((inputField, i) => {
        const inputFieldType = inputField.getAttribute('type');

        // Some inputs are hidden and should not be validated
        // Some inputs are display none after selecting other options, patient vs stock
        // e.g checkboxes for bundled receivers
        let isHidden = false;
        if (
          inputField.closest('.is-hidden') ||
          inputField.closest('.configurator__section').style.display === 'none' ||
          inputField.disabled
        ) {
          isHidden = true;
        } else {
          isHidden = false;
        }

        // If input type text and has .form-control class
        // e.g Patient Name
        if (
          inputFieldType === 'text' &&
          inputField.classList.contains('form-control') &&
          isHidden == false
        ) {
          itemsToValidate.push(inputField);
          if (inputField.value === '') {
            if (debugFunction) {
              console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse);
            }
            // If displayError is true but also if the inputField has a parent with this class, otherwise do nothing
            displayError
              ? inputField.closest('.form-group')
                ? inputField.closest('.form-group').classList.add('is-invalid')
                : null
              : null;
            checkQuestionsInvalid.push(wrapper);
          } else {
            if (debugFunction) {
              console.log('%c Item ' + i + ' Valid ', consoleChildTrue);
            }
            inputField.closest('.form-group')
              ? inputField.closest('.form-group').classList.remove('is-invalid')
              : null;
            // Check if an invalid question exists and remove it now that it is valid
            const findQuestion = checkQuestionsInvalid.indexOf(wrapper);
            if (findQuestion > 0) {
              checkQuestionsInvalid.splice(findQuestion, 1);
            }
          }
          questionToValidateConditional = checkQuestionsInvalid.length > 0;
        }

        if (
          inputFieldType === 'file' &&
          inputField.classList.contains('configurator__input') &&
          isHidden == false
        ) {
          itemsToValidate.push(inputField);
          if (inputField.value === '') {
            if (debugFunction) {
              console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse);
            }
            // If displayError is true but also if the inputField has a parent with this class, otherwise do nothing
            displayError
              ? inputField.closest('.form-group')
                ? inputField.closest('.form-group').classList.add('is-invalid')
                : null
              : null;
            checkQuestionsInvalid.push(wrapper);
          } else {
            if (debugFunction) {
              console.log('%c Item ' + i + ' Valid ', consoleChildTrue);
            }
            inputField.closest('.form-group')
              ? inputField.closest('.form-group').classList.remove('is-invalid')
              : null;
            // Check if an invalid question exists and remove it now that it is valid
            const findQuestion = checkQuestionsInvalid.indexOf(wrapper);
            if (findQuestion > 0) {
              checkQuestionsInvalid.splice(findQuestion, 1);
            }
          }
          questionToValidateConditional = checkQuestionsInvalid.length > 0;
        }
      });

      // For Selects
      // e.g Warranty
      // If select menu option is first item and that options value is blank then error
      const selectFields = wrapper.querySelectorAll('select');
      selectFields.forEach((selectField, i) => {
        let isHidden = false;
        if (
          selectField.closest('.disabled-div') ||
          selectField
            .closest('.is-required-wrapper')
            .querySelector('.form-select__el.is-disabled') ||
          selectField.classList.contains('is-disabled')
        ) {
          isHidden = true;
        } else {
          isHidden = false;
        }

        if (isHidden == false) {
          if (selectField.closest('product-dropdown')) {
            // Inside a product dropdown so do nothing
          } else if (selectField.closest('.configurator__accessories-filters')) {
            // Inside a filter so do nothing
          } else {
            itemsToValidate.push(selectField);
            if (
              selectField.options[selectField.selectedIndex].index === 0 &&
              selectField.options[0].value === ''
            ) {
              if (debugFunction) {
                console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse);
              }
              displayError
                ? selectField
                    .closest('.form-select')
                    ?.querySelector('.form-select__el')
                    ?.classList.add('is-invalid')
                : null;
              checkQuestionsInvalid.push(wrapper);
            } else {
              if (debugFunction) {
                console.log('%c Item ' + i + ' Valid ', consoleChildTrue);
              }
              selectField
                .closest('.form-select')
                ?.querySelector('.form-select__el')
                ?.classList.remove('is-invalid');
              // Check if an invalid question exists and remove it now that it is valid
              const findQuestion = checkQuestionsInvalid.indexOf(wrapper);
              if (findQuestion > 0) {
                checkQuestionsInvalid.splice(findQuestion, 1);
              }
            }
            questionToValidateConditional = checkQuestionsInvalid.length > 0;
          }
        }
      });

      // Textarea
      // e.g Special instructions
      // Check if empty
      const textareaFields = wrapper.querySelectorAll('textarea');
      if (textareaFields.length > 0) {
        textareaFields.forEach((textareaField, i) => {
          itemsToValidate.push(textareaField);
          if (textareaField.value === '') {
            if (debugFunction) {
              console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse);
            }
            displayError
              ? textareaField.closest('.form-group')
                ? textareaField.closest('.form-group').classList.add('is-invalid')
                : null
              : null;
            checkQuestionsInvalid.push(wrapper);
          } else {
            if (debugFunction) {
              console.log('%c Item ' + i + ' Valid ', consoleChildTrue);
            }
            textareaField.closest('.form-group')
              ? textareaField.closest('.form-group').classList.remove('is-invalid')
              : null;
            const findQuestion = checkQuestionsInvalid.indexOf(wrapper);
            if (findQuestion > 0) {
              checkQuestionsInvalid.splice(findQuestion, 1);
            }
          }
          questionToValidateConditional = checkQuestionsInvalid.length > 0;
        });
      }

      // Audiogram
      if (wrapper.querySelector('.audiogram__graph-frame')) {
        const questionValuesRight = [];
        const questionValuesLeft = [];
        const rightAudiogram = wrapper.querySelector('#graphRightEar');
        const rightAudiogramInputs = rightAudiogram
          ? rightAudiogram.querySelector('.audiogram__input').querySelectorAll('input')
          : null;

        if (rightAudiogram) {
          rightAudiogramInputs.forEach((input) => {
            questionValuesRight.push(+input.value);
          });
        } else {
          questionValuesRight.push(1);
        }

        const leftAudiogram = wrapper.querySelector('#graphLeftEar');
        const leftAudiogramInputs = leftAudiogram
          ? leftAudiogram.querySelector('.audiogram__input').querySelectorAll('input')
          : null;
        if (leftAudiogram) {
          leftAudiogramInputs.forEach((input) => {
            questionValuesLeft.push(+input.value);
          });
        } else {
          questionValuesLeft.push(1);
        }

        // If sum is 0 then nothing has been updated on graph
        const questionValuesRightSum = questionValuesRight.reduce(
          (partialSum, a) => partialSum + a,
          0,
        );
        // If sum is 0 then nothing has been updated on graph
        const questionValuesLeftSum = questionValuesLeft.reduce(
          (partialSum, a) => partialSum + a,
          0,
        );

        // If either side has been updated show the summary
        if (questionValuesRightSum == 0 || questionValuesLeftSum == 0) {
          questionToValidateConditional = true;
          checkQuestionsInvalid.push(wrapper);
        } else {
          questionToValidateConditional = false;
          // Check if an invalid question exists and remove it now that it is valid
          const findQuestion = checkQuestionsInvalid.indexOf(wrapper);
          if (findQuestion > 0) {
            checkQuestionsInvalid.splice(findQuestion, 1);
          }
        }
      }

      if (checkQuestionsInvalid.length > 0) {
        if (debugFunction) {
          console.log('%c Items not valid: ' + checkQuestionsInvalid.length, consoleChildFalse);
        }
      } else {
        if (debugFunction) {
          console.log('%c Items not valid: ' + checkQuestionsInvalid.length, consoleChildTrue);
        }
      }

      if (questionToValidateConditional) {
        if (debugFunction) {
          console.log('%c ' + heading + ' Not Valid', consoleChildFalse);
        }
        // If error message already exists do nothing
        if (errorMessageList.querySelector('#' + uniqueId + '')) {
          // Do nothing
        } else {
          // Add errored questions
          // We are using the string from the heading field as it is translatable
          const node = document.createElement('li');
          const textnode = document.createTextNode(heading);
          node.appendChild(textnode);
          node.setAttribute('id', uniqueId);
          node.setAttribute('class', checkSide(wrapper));

          const spanSide = document.createElement('span');
          spanSide.classList.add('side');
          if (checkSide(wrapper) === EARMOLD_SELECTION.right) {
            // Use translated side string
            spanSide.innerHTML = rightSideString;
            node.prepend(spanSide);
          } else if (checkSide(wrapper) === EARMOLD_SELECTION.left) {
            // Use translated side string
            spanSide.innerHTML = leftSideString;
            node.prepend(spanSide);
          }

          errorMessageList.appendChild(node);

          let rightSideWidth = '';
          let leftSideWidth = '';

          // Equalise the width of the side strings (Left and Right for example)
          if (document.querySelector('.configurator_summary__errors .Right .side')) {
            rightSideWidth = document
              .querySelector('.configurator_summary__errors .Right .side')
              .getBoundingClientRect().width;
          }
          if (document.querySelector('.configurator_summary__errors .Left .side')) {
            leftSideWidth = document
              .querySelector('.configurator_summary__errors .Left .side')
              .getBoundingClientRect().width;
          }
          if (rightSideWidth > leftSideWidth) {
            document
              .querySelectorAll(
                '.configurator_summary__errors .Right .side, .configurator_summary__errors .Left .side',
              )
              .forEach((item) => {
                item.setAttribute('style', 'width:' + rightSideWidth + 'px; text-align:center;');
              });
          } else if (rightSideWidth < leftSideWidth) {
            document
              .querySelectorAll(
                '.configurator_summary__errors .Right .side, .configurator_summary__errors .Left .side',
              )
              .forEach((item) => {
                item.setAttribute('style', 'width:' + leftSideWidth + 'px; text-align:center;');
              });
          } else if (rightSideWidth === leftSideWidth) {
            document
              .querySelectorAll(
                '.configurator_summary__errors .Right .side, .configurator_summary__errors .Left .side',
              )
              .forEach((item) => {
                item.setAttribute('style', 'width:' + rightSideWidth + 'px; text-align:center;');
              });
          }
        }
        // Add error class from parent question
        displayError ? wrapper.classList.add('has-error') : null;
        // If this string exists in the array dont push it again
        // -1 means it has not been found
        const findQuestion = checkPageQuestions.indexOf(uniqueId);
        if (findQuestion < 0) {
          checkPageQuestions.push(uniqueId);
        }
        const findHeading = checkPageQuestionsHeadings.indexOf(heading);
        if (findHeading < 0) {
          checkPageQuestionsHeadings.push(heading);
        }
      } else {
        if (debugFunction) {
          console.log('%c ' + heading + ' Valid ', consoleChildTrue);
        }
        // If error message exists remove it
        if (errorMessageList.querySelector('#' + uniqueId + '')) {
          errorMessageList.querySelector('#' + uniqueId + '').remove();
        }
        // Remove error class from parent question
        wrapper.classList.remove('has-error');
        // If this string exists in the array remove it
        // -1 means it has not been found
        const findQuestion = checkPageQuestions.indexOf(uniqueId);
        if (findQuestion >= 0) {
          checkPageQuestions.splice(findQuestion, 1);
        }
        const findHeading = checkPageQuestionsHeadings.indexOf(heading);
        if (findHeading >= 0) {
          checkPageQuestionsHeadings.splice(findHeading, 1);
        }
      }
    });

    // Check page is valid
    return checkPage(displayError);
  }

  function checkSide(question) {
    let inputSide = '';
    const checkSide = question.closest('.configurator__section__fields')
      ? question
          .closest('.configurator__section__fields')
          .classList.contains('configurator__section__fields--right')
      : null;

    if (
      question
        .closest('.configurator__section')
        .querySelector('.configurator__section__fields--disabled')
    ) {
      inputSide = EARMOLD_SELECTION.binaural;
    } else {
      if (question.closest('.configurator__section__fields')) {
        // Right side
        if (checkSide) {
          inputSide = EARMOLD_SELECTION.right;
        } else {
          inputSide = EARMOLD_SELECTION.left;
        }
      } else if (question.closest('.configurator__section__monoBorder')) {
        inputSide = null;
      }
    }
    return inputSide;
  }

  // Submit button
  addToCartBtn?.addEventListener('click', (e) => {
    e.preventDefault();

    if (debugFunction) {
      console.log('%c Click Submit ', consoleInfo);
    }

    checkPageQuestions = [];

    // clear errors list only if it's hidden (initial load)
    if (document.querySelector('.configurator_summary__errors').classList.contains('is-hidden')) {
      document.querySelector('.configurator_summary__errors ul').innerHTML = '';
    }

    const isValid = checkQuestionGeneric(true);
    const isLastnameValid = validateRegex();

    if (isValid && isLastnameValid) {
      checkoutActions(e.target);
    }
  });

  /**
   * Checkout actions
   * 1. Show checkout modal
   * 2. Save and return to cart (when edit product from cart)
   */
  const checkoutActions = (elem) => {
    const saveAndReturnButtonId = elem.getAttribute('data-button-id');
    const isSaveAndReturn = elem.getAttribute('data-save-and-return');
    const isPostback = typeof __doPostBack === 'function';
    // Save and return to cart
    if (saveAndReturnButtonId && isSaveAndReturn == '1' && isPostback) {
      __doPostBack(saveAndReturnButtonId, '', true, '', '', false, false);
      return;
    }
    // Show checkout modal
    document.querySelector('.configurator_modal').showModal();
  };

  // Check on page load (when dom is completed). Fix when return to configuration from edit product in cart
  document.onreadystatechange = () => {
    if (document.readyState === 'complete') {
      checkQuestionGeneric(false);
    }
  };
  // Observer required as we need to wait for the disabled fields to be added
  const audioGramQuestionSelector = document.querySelector('#cssConfigureAudiogram');
  /* eslint-disable-next-line */
  const observerDynamicAreas = new MutationObserver(function (mutations) {
    if (
      document.querySelector('.configurator__section__fields--disabled') &&
      document.querySelector('.audiogram__graph') &&
      document.querySelector('.configurator__label--required')
    ) {
      observerDynamicAreas.disconnect();
      // no need to run it separately for audiogram
      audioGramQuestionSelector ? observerAudiogramAreas.disconnect() : null;
      checkQuestionGeneric(false);
      // detect change in required fields
      const requiredFields = [
        ...document.querySelectorAll(
          '.is-required-wrapper:not([style*="display:none"]):not(.configurator__section__fields--disabled) input, .is-required-wrapper:not([style*="display:none"]):not(.configurator__section__fields--disabled) select',
        ),
      ];
      for (let field of requiredFields) {
        field.addEventListener('change', function () {
          if (debugFunction) {
            console.log('%c Change detected ', consoleInfo);
          }
          // Reset the list of options or there are issues with id's and labels in the list
          document.querySelector('.configurator_summary__errors ul').innerHTML = '';
          checkQuestionGeneric(false);
        });
      }
      // Audiogram specific checks
      const audiogramInputs = [...document.querySelectorAll('#audiogram input.form-control')];
      for (let input of audiogramInputs) {
        input.addEventListener('change', function () {
          // Reset the list of options or there are issues with id's and labels in the list
          document.querySelector('.configurator_summary__errors ul').innerHTML = '';
          checkQuestionGeneric(false);
        });
      }
      const audiogramGraphs = [
        ...document.querySelectorAll('#audiogram .audiogram__graph, #audiogram .btn-secondary'),
      ];
      for (let graph of audiogramGraphs) {
        graph.addEventListener('click', function () {
          // Reset the list of options or there are issues with id's and labels in the list
          document.querySelector('.configurator_summary__errors ul').innerHTML = '';
          checkQuestionGeneric(false);
        });
      }
    }
  });
  observerDynamicAreas.observe(document.querySelector('.configurator_controllers'), {
    attributes: true,
    childList: true,
    characterData: false,
    subtree: true,
  });

  /* eslint-disable-next-line */
  const observerAudiogramAreas = new MutationObserver(function (mutations) {
    if (document.querySelector('.audiogram__graph')) {
      observerAudiogramAreas.disconnect();
      // Audiogram specific checks
      const audiogramInputs = [...document.querySelectorAll('#audiogram input.form-control')];
      for (let input of audiogramInputs) {
        input.addEventListener('change', function () {
          // Reset the list of options or there are issues with id's and labels in the list
          document.querySelector('.configurator_summary__errors ul').innerHTML = '';
          checkQuestionGeneric(false);
        });
      }
      const audiogramGraphs = [
        ...document.querySelectorAll('#audiogram .audiogram__graph, #audiogram .btn-secondary'),
      ];
      for (let graph of audiogramGraphs) {
        graph.addEventListener('click', function () {
          // Reset the list of options or there are issues with id's and labels in the list
          document.querySelector('.configurator_summary__errors ul').innerHTML = '';
          checkQuestionGeneric(false);
        });
      }
    }
  });
  audioGramQuestionSelector
    ? observerAudiogramAreas.observe(audioGramQuestionSelector, {
        attributes: true,
        childList: true,
        characterData: false,
        subtree: true,
      })
    : null;

  // detect change in side visible to see if there are more or less required questions now
  const sections = [
    ...document.querySelectorAll('.configurator_controllers .configurator__section'),
  ];
  for (let section of sections) {
    section.addEventListener('change', function () {
      if (debugFunction) {
        console.log('%c Change on Section detected ', consoleInfo);
      }
      // Reset the list of options or there are issues with id's and labels in the list
      document.querySelector('.configurator_summary__errors ul').innerHTML = '';

      // If errors already showing then run validation again to pick up newly showing field
      // Else dont run validation
      if (
        !document.querySelector('.configurator_summary__errors').classList.contains('is-hidden')
      ) {
        checkQuestionGeneric(true);
      } else {
        checkQuestionGeneric(false);
      }
    });
  }

  // detect change in any question
  const questions = [
    ...document.querySelectorAll(
      '.configurator_controllers input, .configurator_controllers select',
    ),
  ].filter(function (elem) {
    if (elem.getAttribute('type') !== 'hidden') {
      return elem;
    }
  });
  for (let question of questions) {
    question.addEventListener('change', function () {
      if (debugFunction) {
        console.log('%c Change in question detected ', consoleInfo);
      }
      // Reset the list of options or there are issues with id's and labels in the list
      document.querySelector('.configurator_summary__errors ul').innerHTML = '';

      // If errors already showing then run validation again to pick up newly showing field
      // Else dont run validation
      setTimeout(function () {
        if (
          !document.querySelector('.configurator_summary__errors').classList.contains('is-hidden')
        ) {
          checkQuestionGeneric(true);
        } else {
          checkQuestionGeneric(false);
        }
      }, 100);
    });
  }

  // Close error message
  const closeBtn = document.querySelector('.close_error_message');
  closeBtn?.addEventListener('click', () => {
    summaryErrors.classList.add('is-hidden');
  });
}
